export default __webpack_public_path__ + "9c61d4d0cb47eb1c2af7eb3106bd053d.mov";